import React, { Component } from 'react';
import { Form, Button, Row, Col, Select, InputNumber, message } from 'antd';
import { connect } from 'react-redux';
import * as actions from '../redux/actions/collector';

class Transfer extends Component {
    formRef = React.createRef();
    showMessage=()=>{
        if (this.props.message) {
            message.success(this.props.message);
        }
        if (this.props.error) {
            message.error('Error');
        }
    }
    onFinish = async (values) => {
        await this.props.onSubmit({ employeeId: values.employee, amount: values.amount }, this.props.token);
        setTimeout(this.showMessage,1000);
        this.formRef.current.resetFields();
    };

    onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };

    render() {
        let select = null;
        const { Option } = Select;
        let option = null;
        let collector = [];
        const employees = this.props.employees;
        if (employees) {
            employees.filter(employee => employee.roles[0].id === 3).map(c => {
                collector.push(c);
            });
        }
        if (collector.length > 0) {
            option = collector.map(c => {
                return <Option key={c.id} value={c.id}>{c.name}</Option>
            });
        }
        if (option) {
            select = (<Select
                showSearch
                optionFilterProp="children"
                filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
            >
                {option}
            </Select>);
        }
        return (
            <>
                <div style={{ fontSize: '24px', paddingLeft: '50px' }}>Transfer collector</div>
                <br />
                <Row justify="left" align="middle" style={{ paddingLeft: '60px' }}>
                    <Col lg={20} sm={20}>
                        <Form
                            name="basic"
                            layout="inline"
                            onFinish={this.onFinish}
                            onFinishFailed={this.onFinishFailed}
                            ref={this.formRef}
                        >
                            <Form.Item
                                style={{ width: '200px' }}
                                label="Employee"
                                name="employee"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Select employee',
                                    },
                                ]}
                            >
                                {select}
                            </Form.Item>
                            <Form.Item
                                style={{ width: '150px' }}
                                name="amount"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Enter the amount',
                                    }
                                ]}
                            >
                                <InputNumber
                                    style={{ width: '100%' }}
                                    placeholder="amount"
                                    formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')} />
                            </Form.Item>
                            <Form.Item >
                                <Button type="primary" htmlType="submit">
                                    Submit
                            </Button>
                            </Form.Item>
                        </Form>
                    </Col>
                </Row>
            </>
        )
    }

};
const mapStateToProps = state => {
    return {
        token: state.auth.token,
        message: state.collector.message,
        error: state.collector.error,
        employees: state.employee.employees,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        onSubmit: (request, token) => dispatch(actions.collectorTransaction(request, token)),
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Transfer);